import React from "react";
import InnerPopup from "./InnerPopup";
import { IoIosInformationCircleOutline } from "react-icons/io";
import { withTranslation } from "react-i18next";

const CancelledBetDeskonPopup = (props) => {
  const { onClose } = props;

  // const callProcessSubmit = () => {
  //     props.submitProcessOk();
  // }
  return (
    <div className="confirmation_modal">
      <InnerPopup onCloseModal={onClose}>
        <div className="betdiskon_poupcontent">
          <div className="confirm_img_conatiner">
            <IoIosInformationCircleOutline />
          </div>
          <p>{props.t("cancel")}</p>
          <div className="bet_txt">{props.t("cancel_message")}</div>

          <div className="confirm_poupcontent_btns">
            <button className="btn" onClick={onClose}>
              OK
            </button>
            {/* <button className="btn" onClick={callProcessSubmit}>
                            Yes
                        </button> */}
          </div>
        </div>
      </InnerPopup>
    </div>
  );
};

export default withTranslation()(CancelledBetDeskonPopup);
